import { render, staticRenderFns } from "./WaterHammerSettings.vue?vue&type=template&id=f641ee4a&"
import script from "./WaterHammerSettings.vue?vue&type=script&lang=js&"
export * from "./WaterHammerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports